// Copyright (c) 2017 Deere & Company

import Modal, {getDefaultState as getModalDefaultState} from '../../shared/state/modal';
import PrintRegistrationFormModal, {getDefaultState as getPrintRegistrationFormModalDefaultState} from './print-registration-form-modal';
import t from 'tcomb';

const RegistrationModals = t.struct({
    confirmDeleteModal: t.Bool,
    customerSearchModal: t.Bool,
    printRegistrationFormModal: PrintRegistrationFormModal,
    registrationStatusChangeModal: Modal
}, 'RegistrationModals');

export const getDefaultState = () =>
    new RegistrationModals({
        confirmDeleteModal: false,
        customerSearchModal: false,
        printRegistrationFormModal: getPrintRegistrationFormModalDefaultState(),
        registrationStatusChangeModal: getModalDefaultState()
    });

export default RegistrationModals;



// WEBPACK FOOTER //
// ./src/product/product-registration/state/registration-modals.js